export default "__VITE_ASSET__DrUXELrl__"